import { useGetGenericsQuery } from '@/features/slice/products/generic/generic-api-slice';
import { useModal, useUrlFilter, useUrlPagination } from '@/hooks';

import { MODAL_ROUTE } from '../../../../constants';

export const useGenericList = () => {
    const { debouncedSearchText, sortBy, sortOrder } = useUrlFilter();
    const { page, limit } = useUrlPagination();
    const { openModal } = useModal();

    const { data, isLoading, isFetching, isError, error } = useGetGenericsQuery(
        {
            page,
            limit,
            search: debouncedSearchText,
            sort_by: sortBy,
            sort_order: sortOrder,
        },
    );

    const handleCreateGeneric = () => {
        openModal(MODAL_ROUTE.CREATE_PRODUCT_GENERIC);
    };

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        handleCreateGeneric,
    };
};
